import DefaultAwardIcon from '@assets/icons/DefaultAwardIcon'
import { colors } from '@globals/themes/defaultTheme'
import { MediaObjectUrl } from '@kudos/http-client'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import AvatarWrapper from '@shared/avatar/AvatarWrapper'

const cardStyle: SxProps = {
  backgroundColor: colors.irisUltraLight,
  borderWidth: 0,
  borderRadius: 4,
}

type TvAwardBadgeProps = {
  name: string
  badgeUrls: MediaObjectUrl | null
}
const TvAwardBadge: React.FC<TvAwardBadgeProps> = ({ name, badgeUrls }) => {
  return (
    <Paper component={Stack} direction="row" alignItems="center" p={2} sx={cardStyle}>
      <AvatarWrapper size={80} media={badgeUrls}>
        {!badgeUrls ? <DefaultAwardIcon /> : null}
      </AvatarWrapper>
      <Typography variant="h1" ml={3} mt={0}>
        {name}
      </Typography>
    </Paper>
  )
}

export default TvAwardBadge
